import React, { Component } from 'react';

class MemberContainer extends Component {
  render() {
    return <div id="member-app">{this.props.children}</div>;
  }
}

export default MemberContainer;
